export function clamp(min: number, max: number) {
  return (n: number) =>
    isNaN(n) || !n || typeof n !== "number" ? max : Math.min(max, Math.max(min, n));
}

export const percentify = clamp(0, 100);

/**
 * This function extract the image out of gif for pause state
 * and update the reference of canvas with that image
 * @param {HTMLImageElement} imgRef
 * @param {HTMLCanvasElement} canvasRef
 * @return {void}
 */
export function extractImageAndUpdateReference(
  imgRef: HTMLImageElement,
  canvasRef: HTMLCanvasElement,
) {
  const imageWidth = imgRef.width;
  const imageHeight = imgRef.height;
  canvasRef.width = imageWidth;
  canvasRef.height = imageHeight;
  canvasRef.getContext("2d")?.drawImage(imgRef, 0, 0, canvasRef.width, canvasRef.height);
}

export const selectCompressedImage = (sources: {
  original?: { url: string; width?: number; height?: number };
  compressed?: { url: string; width?: number; height?: number };
}) => {
  const { original, compressed } = sources;
  return compressed?.url ? compressed : original;
};
